import { render, staticRenderFns } from "./qrcode-scan.vue?vue&type=template&id=53144dfd&"
import script from "./qrcode-scan.vue?vue&type=script&lang=js&"
export * from "./qrcode-scan.vue?vue&type=script&lang=js&"
import style0 from "./qrcode-scan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports